import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { useCookies } from "react-cookie";

const DarkMode = () => {
    const [cookie, setCookie] = useCookies(["dark"]);
    useEffect(() => {
        cookie.dark == "true" ? addDarkMode() : removeDarkMode();
    }, [cookie.dark]);

    const changeMode = (e) => {
        setCookie("dark", e.target.checked, { path: "/" });
    };

    const addDarkMode = () => {
        document.getElementById("app-body").setAttribute("class", "dark-mode");
    };

    const removeDarkMode = () => {
        document.getElementById("app-body").classList.remove("dark-mode");
    };

    return (
        <div className="d-flex align-items-center">
            ☀️
            <Form>
                <Form.Check
                    type="switch"
                    id="dark-switch"
                    variant="dark"
                    defaultChecked={cookie.dark == "true" ? true : false}
                    onClick={(e) => changeMode(e)}
                />
            </Form>
            🌙
        </div>
    );
};

export default DarkMode;
